import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Navbar, Typography, Button } from "@material-tailwind/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import BlogImg1 from "./dashboard/images/blog1_new.jpg";
import BlogImg2 from "./dashboard/images/blog2_new.jpg";
import BlogImg3 from "./dashboard/images/blog3_new.jpg";
import DecoRightBlog1 from "./dashboard/images/Deco-right-blog1.png";
import DecoRightBlog2 from "./dashboard/images/Deco-right-blog2.png";
import DecoRightBlog3 from "./dashboard/images/Deco-right-blog3.png";
import DecoRightBlog4 from "./dashboard/images/Deco-right-blog4.png";
import "./styles/tailwind.css";

const blogData = [
  {
    id: 1,
    title: "AECP's Solution to Boosting Efficiency in Growing Businesses",
    author: "Author",
    date: "15th May,2025",
    image: BlogImg1,
    category: "Product",
    content: `For businesses experiencing growth, one of the most significant challenges is maintaining project efficiency. As teams expand, managing tasks, deadlines, communication, and collaboration becomes increasingly complex. Traditional project management methods—often reliant on spreadsheets, emails, and outdated software—can lead to confusion, miscommunications, and missed deadlines, especially when your team is scaling. But with AECP’s cloud-based project management platform, businesses can streamline operations, increase efficiency, and set themselves up for sustainable growth.`,
    contentTitle3:
      "Overcoming Project Management Challenges for Growing Businesses",
    content4: `Small businesses, startups, and enterprises in their growth phase often struggle with keeping up with the pace of their expanding operations. Without a unified system, multiple teams or departments may work in silos, creating gaps in communication and collaboration. This can result in inefficient processes, increased operational costs, and missed opportunities.
Take the example of a digital marketing agency handling multiple ongoing campaigns across various platforms. Without an effective system in place, teams may fail to track progress accurately or communicate updates on time, leading to overlapping tasks, confusion, and missed deadlines. This is a common challenge that many growing businesses face.
With AECP’s cloud-based project management solution, businesses can unify all aspects of their project management process—task assignments, team collaboration, progress tracking, and client updates—into one easy-to-use platform

Sign Up Now to streamline your project management and take your business to the next level.`,
    contentTitle: "AECP’s Cloud-Based Project Management: The Solution",
    content2: `
    AECP’s cloud platform offers a dynamic, scalable project management system designed to grow with your business. Whether you're managing multiple campaigns, products, or teams, AECP integrates all project-related activities into a single dashboard. This means no more juggling between emails, spreadsheets, and various communication tools—everything is in one place, easily accessible from anywhere.
    `,
    contentTitle2: "Key Features of AECP’s Cloud-Based Project Management:",
    content3: `Centralized Project Dashboard: AECP’s intuitive dashboard allows you to oversee the progress of all your projects in one view. Whether you’re working on a large-scale marketing campaign or a product launch, you can track key milestones, deadlines, and team contributions from a single location.
    Task Assignment & Tracking: No more confusion over who is responsible for what. AECP enables team leaders to assign tasks, set deadlines, and monitor progress in real time. For example, if your content team is working on several blog posts for a campaign, AECP’s platform helps ensure that tasks are completed on time, keeping the campaign on track.
    Collaboration Tools: AECP makes it easy to collaborate with team members, regardless of their location. Teams can communicate via instant messaging, leave comments on tasks, and share files directly within the platform. This leads to quicker problem resolution and improved team cohesion.
    Real-Time Updates & Notifications: AECP’s system ensures that your team is always up-to-date. Automated notifications keep everyone informed about task changes, updates, and upcoming deadlines, so nothing falls through the cracks.
    Scalability: As your business grows, AECP grows with you. The platform can scale to handle an increasing number of projects, tasks, and team members without compromising performance or user experience.
    `,
    contentTitle4:"Real-World Example: The Digital Marketing Agency",
    content5:`Imagine a digital marketing agency with several active campaigns for different clients. Without a cloud-based system, it’s easy for project managers to lose track of deadlines, assignments, and task dependencies. However, with AECP, the project manager can assign specific tasks to team members, set clear deadlines, and track progress in real time. The platform also allows them to communicate directly with team members, making it easy to share updates, feedback, or requests.
For example, let’s say one of the content writers is assigned to create blog posts for an SEO campaign. With AECP, the project manager can track the writer’s progress and provide real-time feedback. If any delays occur, the project manager can immediately reassign tasks or adjust timelines to meet the campaign’s deadline.
By centralizing all these activities in one platform, AECP eliminates confusion, increases accountability, and ensures that the team stays aligned and efficient.
Discover More About AECP to learn how AECP can help your business streamline project management.

    `,
    contentTitle5:"Why AECP is the Ultimate Solution for Growing Businesses",
    content6:`AECP’s cloud-based project management platform is designed specifically for businesses that need a scalable, efficient, and user-friendly solution. By integrating communication, collaboration, and task management into one centralized system, AECP helps businesses reduce inefficiencies, eliminate silos, and boost productivity.

    According to Anand Thayalaguru, CEO and Founder of Swifterz:
"With AECP’s cloud-based platform, businesses can enjoy a seamless project management experience. It’s designed to scale with your company, eliminating the need for disjointed, outdated tools."
As businesses grow, the complexity of managing projects multiplies. AECP provides the tools needed to stay organized, increase team productivity, and ensure smooth operations, all while supporting scalability. Whether you’re working with a small team or handling large, complex projects, AECP simplifies project management so that you can focus on driving your business forward.

    `,
    contentTitle6:"Get Started Today: Boost Your Business Efficiency with AECP",
    content7:`If you’re a growing business looking for a project management solution that can keep up with your pace, AECP is the answer. Don’t let inefficiency and outdated systems hold you back. Sign up for AECP today and experience the difference a streamlined, cloud-based platform can make for your business.
Take control of your projects, boost efficiency, and scale your business with AECP’s cloud-based project management solution. Join the growing businesses already benefiting from AECP’s dynamic, user-friendly platform.
Register for a Free Trial and see how AECP can improve the way your team works together.
Ready to elevate your project management game? AECP’s features are tailored to your business needs. Start today and experience the power of seamless collaboration.
Discover More About AECP and find out how AECP can help simplify your project management processes, reduce inefficiencies, and support your growing business.
    `,
    contentTitle7:"",
    content8:"",
  },

  {
    id: 2,
    title: "How AECP’s Workflow Automation Supports Expansion",
    author: "Author",
    date: "15th May,2025",
    image: BlogImg2,
    category: "Product",
    content: `As businesses expand, they often face an influx of new processes, larger teams, and increasingly complex workflows. These growing pains can overwhelm existing resources, introduce inefficiencies, and potentially compromise the quality of customer service and overall productivity. In the fast-paced and competitive business environment of the UAE, companies need solutions that not only help them keep up but also enable them to thrive. AECP’s workflow automation is the answer, offering a robust tool to help businesses navigate the challenges of growth by reducing manual tasks, speeding up processes, and improving consistency.`,
    contentTitle:
      "AECP’s Workflow Automation: The Solution to Scaling Operations",
    content2: `
    AECP’s workflow automation provides the perfect solution for businesses navigating the challenges of growth. With AECP, businesses can automate repetitive tasks, freeing up valuable time for teams to focus on innovation and improving customer experiences. The platform offers a comprehensive suite of tools designed to integrate seamlessly into your existing operations and scale with your business.
    `,
    contentTitle2: "Key Features of AECP’s Workflow Automation:",
    content3: `Automated Task Assignments: AECP allows businesses to automatically assign tasks based on predefined rules. For example, in an eCommerce business, once an order is placed, AECP can automatically assign fulfillment tasks to the logistics team, track inventory levels, and trigger an alert to update stock quantities.
    Order Processing & Inventory Management: Automation tools ensure that orders are processed swiftly and inventory is updated in real-time. For an eCommerce company based in the UAE, where fast delivery and inventory accuracy are paramount, this feature helps streamline the supply chain, minimize errors, and reduce manual effort. This leads to faster fulfillment times, improved customer satisfaction, and reduced costs.
    Customer Support Automation: AECP’s platform automates customer support workflows, such as ticket routing and escalation. When a customer submits a query or a complaint, AECP’s system automatically categorizes the request and routes it to the correct department, ensuring faster resolution times and a better customer experience. For example, a customer complaint regarding a delayed shipment can be automatically flagged and sent to the support team for immediate action.
    Process Monitoring & Reporting: AECP’s real-time monitoring tools allow businesses to track the progress of automated workflows and generate reports for continuous improvement. This gives businesses in the UAE the ability to track performance, optimize workflows, and ensure that all processes are running smoothly as they scale.
    Seamless Integration: AECP integrates with your existing business tools, such as customer relationship management (CRM) software, inventory management systems, and payment gateways. This creates a unified workflow across all platforms, reducing the need for manual data entry and ensuring smooth transitions between processes.
    `,
    contentTitle3:
      "The Challenges of Business Growth",
    content4: `
    Businesses experiencing growth are often confronted with the daunting task of managing more projects, teams, and customers without losing their ability to maintain quality. Whether it’s handling an increase in sales, customer inquiries, or operations, the complexity of managing these functions manually becomes unsustainable.
    For instance, a growing eCommerce business might need to handle hundreds or even thousands of orders, manage inventory, process customer support tickets, and more—all while ensuring accuracy and timely responses. When done manually, this can lead to errors, delays, and frustrated customers, which could harm the business's reputation and result in lost revenue.
Moreover, in markets like the UAE, where competition is fierce, businesses need to stay ahead by offering a seamless, fast, and efficient customer experience. Failing to do so can result in lost opportunities and customer churn, ultimately affecting business growth.
Sign Up Now to explore AECP’s workflow automation tools and see how they can help streamline your processes.

    `,
    contentTitle4:"How AECP Helps Businesses in the UAE",
    content5:`In the UAE, where businesses are expected to meet high standards of service and efficiency, AECP’s automation tools can provide a significant competitive advantage. With the growing demand for fast and reliable customer service, businesses need a system that allows them to automate routine tasks without compromising the quality of their customer interactions.
For example, let’s say an eCommerce company based in Dubai experiences a sudden spike in orders during a holiday sale. AECP’s workflow automation can help the company process and fulfill orders faster, update inventory in real-time, and automatically route customer inquiries to the right department. This ensures that the business can handle the increase in workload without losing its efficiency or customer satisfaction levels.
Additionally, AECP helps businesses comply with regulations in the UAE by providing transparent and auditable workflows. The UAE has strict laws regarding data security, so AECP’s automated workflows are designed to ensure that sensitive information is handled with the highest standards of compliance.
Register for a Free Trial and experience AECP’s seamless integration with your existing systems.

    `,
    contentTitle5:"Real-World Example: The eCommerce Business",
    content6:`Consider an eCommerce business that is rapidly expanding in the UAE market. As sales grow, managing customer orders, inventory updates, and support requests manually becomes increasingly difficult. With AECP, this business can automate its order processing, inventory management, and customer support workflows.
When an order is placed, AECP automatically assigns tasks to the warehouse team to pick and pack the item, updates inventory, and triggers a shipping label. At the same time, AECP sends an automated notification to the customer with order tracking details. This end-to-end automation ensures that the business operates efficiently, even during peak seasons, without overwhelming staff or causing delays.
As Anand Thayalaguru, CEO of Swifterz, puts it:
"Workflow automation through AECP doesn’t just streamline operations—it empowers businesses to handle growth without the growing pains. You can automate repetitive tasks, focus on innovation, and still deliver exceptional customer experiences."

    `,
    contentTitle6:"Why AECP is the Ideal Solution for Growing Businesses in the UAE",
    content7:`AECP’s workflow automation platform is a game-changer for businesses in the UAE, especially those experiencing rapid growth. By automating routine tasks, businesses can reduce operational bottlenecks, improve efficiency, and provide a better customer experience. AECP’s system not only saves time but also reduces errors, improves accuracy, and allows businesses to scale without overwhelming their resources.
Whether you're a fast-growing eCommerce business, a startup scaling operations, or an established enterprise looking to optimize your processes, AECP’s workflow automation can help you maintain high standards of service while scaling quickly.
Discover More About AECP and see how our workflow automation tools can support your business growth.

    `,
    contentTitle7:"Get Started with AECP Today",
    content8:`If you're looking to streamline your operations and support your business’s growth, AECP’s workflow automation is the solution you need. Sign up now and see how AECP can help your business handle the complexities of growth, improve operational efficiency, and enhance customer satisfaction.
AECP empowers businesses in the UAE and beyond to navigate the challenges of growth while maintaining high levels of efficiency and service. Don’t let manual tasks hold you back. Register for a Free Trial today and discover how AECP can help you scale your business with ease.
Ready to transform the way your business handles growth? Get Started Now with AECP’s workflow automation tools and experience seamless, efficient, and scalable operations.

    `,
  },
  {
    id: 3,
    title: "Here’s How AECP Bridges the Gap Across Time Zones",
    author: "Author",
    date: "15th May,2025",
    image: BlogImg3,
    category: "Product",
    content: `The construction and design industry has long been known for its onsite work, with teams collaborating in person on project sites. However, as the world shifts to a more remote-first working model, construction firms—especially those in the UAE—are facing a unique set of challenges when it comes to collaborating across time zones. Distributed teams, suppliers, subcontractors, and clients need a cohesive platform to maintain effective communication, meet deadlines, and ensure projects move forward seamlessly. AECP’s solutions are designed to bridge the gap for remote-first and distributed construction teams, ensuring smooth operations across different time zones.`,
    contentTitle:
      "The Target Audience: Construction Business Owners, Project Managers, and Teams",
    content2: `
    The primary audience for AECP’s remote collaboration tools within the construction and design sector includes construction business owners, project managers, and design teams who oversee large, multifaceted projects. These professionals often work with diverse teams spread across the globe, from architects in Europe to contractors in Asia, suppliers in the Middle East, and project managers in the UAE. In this environment, managing communication, timelines, and resources effectively becomes increasingly difficult.
    `,
    contentTitle2: "Key Challenges Faced by Remote Construction Teams:",
    content3: `Communication Delays: With teams spread across various time zones, the potential for delays in communication becomes high. An important update or query may not receive attention until hours later, which can result in project holdups.
    Time Zone Confusion: Scheduling meetings or coordinating tasks across multiple time zones can be chaotic. Construction project timelines often have tight deadlines, and missing crucial steps due to time zone mismatches can be costly.
    Resource and Task Management: Remote teams need to keep track of tasks, resources, and project timelines effectively. With physical separation, it becomes harder to monitor day-to-day progress, leading to confusion, duplication of work, or even missed deadlines.
    Tracking Multiple Stakeholders: In the construction industry, numerous stakeholders—ranging from subcontractors and suppliers to clients and architects—are involved in the project. Keeping everyone aligned, especially when they’re in different regions, can be an overwhelming task.
    `,
    contentTitle3: "",
    content4: `
    `,
    contentTitle4:"How AECP’s Workflow Automation Helps Tackle Remote Work Challenges",
    content5:`AECP provides construction firms with the tools they need to streamline operations and manage projects across multiple time zones, ensuring global collaboration without the chaos. Here’s how AECP bridges the gap for remote teams:
    `,
    subtitle1:`1. Seamless Communication Across Time Zones`,
    subcontent1:`With AECP, project teams—regardless of their location—can stay connected in real-time. The platform supports automated notifications, updates, and reminders for team members across different time zones, ensuring that everyone is on the same page without the need for constant manual intervention. Communication bottlenecks are reduced, and critical tasks aren’t delayed.`,
    subcontent2:`Real-Life Scenario:`,
    subcontent3:`Imagine a scenario where a construction project in the UAE involves stakeholders in Dubai, London, and New York. AECP’s communication tools allow team members to send and receive automatic updates about project progress, deadlines, and approvals in their local time zones. This eliminates the need for constant back-and-forth emails, ensuring that time-sensitive decisions are made quickly and efficiently.`,
    subcontent4:`Sign Up Now to automate communication and ensure your team stays connected, no matter the time zone.`,

    subtitle2:`2. Intelligent Scheduling Across Time Zones`,
    subcontent5:`Scheduling meetings or coordinating project tasks can be a nightmare when teams work across time zones. AECP solves this problem with intelligent scheduling features that automatically adjust meeting times according to each team member’s local time zone. The platform ensures that all participants have the correct meeting time, minimizing confusion and making it easier to coordinate across borders.`,
    subcontent6:`Real-Life Scenario:`,
    subcontent7:`Consider a project manager in the UAE who needs to schedule a meeting with a subcontractor in Australia, a supplier in India, and an architect in the US. AECP automatically adjusts the meeting time for all participants, ensuring that no one misses a meeting due to time zone confusion.`,
    subcontent8:`Register Today to automate your scheduling and eliminate the hassle of time zone discrepancies.`,
    subtitle3:`3. Centralized Resource and Task Management`,
    subcontent9:`AECP’s task management tools make it easy for remote teams to assign, track, and complete tasks efficiently. Construction projects typically involve numerous moving parts, and AECP centralizes all task management, making it easy for teams to keep track of resources, deadlines, and responsibilities. Tasks are automatically assigned based on availability, and updates are provided in real-time, so remote teams never lose sight of their progress.
`,
    subcontent10:`Real-Life Scenario:`,
    subcontent11:`A project in the UAE is using AECP to manage various tasks—from procurement to design approval. With teams working remotely in different countries, AECP centralizes all updates, assigning tasks based on availability and ensuring that each task is completed on time, regardless of where the team members are located.`,
    subcontent12:`Try AECP Today to streamline resource and task management across your global teams.`,
    subtitle4:`4. Tracking and Aligning Multiple Stakeholders`,
    subcontent13:`Construction projects often require the involvement of numerous stakeholders, including clients, subcontractors, and suppliers. Keeping track of everyone’s progress and ensuring they meet deadlines can be challenging when dealing with remote teams. AECP automates workflow approvals, status reports, and project milestones, ensuring that all stakeholders stay aligned.`,
    subcontent14:`Real-Life Scenario:`,
    subcontent15:`During a construction project in Dubai, AECP’s platform automatically sends updates to contractors in India, suppliers in Qatar, and the project manager in the UAE. Everyone is aligned on the latest project developments, preventing miscommunication and missed deadlines.`,
    subcontent16:`Sign Up Now to bring your stakeholders together on a single platform.`,
   
    contentTitle5:"Why AECP is Essential for Remote Construction Teams in the UAE",
    content6:`As the UAE’s construction industry continues to expand, remote collaboration becomes an increasingly critical factor for success. AECP offers solutions tailored to the construction sector, ensuring that remote teams can coordinate, manage tasks, and stay aligned regardless of where they are based. With AECP’s powerful automation and communication tools, construction businesses in the UAE can scale operations and keep projects on track, even across time zones.
“As more teams work remotely, especially in the construction sector, AECP’s tools help bridge the gap between time zones, ensuring that collaboration and productivity are never hindered by geographic distance,” says Anand Thayalaguru, CEO and Founder of Swifterz.

    `,
    contentTitle6:"Conclusion",
    content7:`AECP’s workflow automation platform is the perfect solution for construction businesses in the UAE facing the challenges of remote work and time zone differences. With its tools for seamless communication, intelligent scheduling, resource management, and stakeholder coordination, AECP helps ensure that your teams are aligned and that projects are completed on time.

    If you’re ready to streamline your remote workflows and boost collaboration across time zones, Sign Up Now to experience AECP’s remote work solutions.
    `,
  },
];

export default function BlogPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogData.find((b) => b.id === Number(id));
   const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
      const onScroll = () => setIsScrolled(window.scrollY > 20);
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, []);

  // Choose background images for design
  const decoImages = [
    DecoRightBlog1,
    DecoRightBlog2,
    DecoRightBlog3,
    DecoRightBlog4,
  ];

  if (!blog) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <Typography variant="h3" className="text-red-500">
          Blog not found
        </Typography>
        <Button onClick={() => navigate("/")}>Go Home</Button>
      </div>
    );
  }

  return (
    <div className="relative h-screen bg-[#ffffff] flex flex-col font-sans overflow-x-hidden">
      {/* Header/Navbar (copied from LandingPage) */}
      <Navbar
              className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 py-0  ${
                isScrolled
                  ? "backdrop-blur-md bg-gray-100 shadow-md text-black"
                  : " bg-gray-100 text-black"
              } border-0`}
              style={{ border: "none" }}
              blurred={true}
              fullWidth={true}
              shadow={false}
            >
              <div className="container mx-auto flex items-center justify-between ">
                <img
                  src={require("./dashboard/images/AECP_logo.png")}
                  alt="AECP Logo"
                  style={{ height: "90px", width: "auto", marginRight: "16px", cursor: "pointer" }}
                  onClick={() => navigate("/")}
                />
                {/* LOGO left-aligned */}
                <div className="flex-1 flex items-center">
                  {/* <Typography
                    variant="h5"
                    className={`text-white font-bold tracking-wider ${
                      isScrolled ? "text-black" : "text-white"
                    }`}
                  >
                    LOGO
                  </Typography> */}
                </div>
                {/* Hamburger Icon for mobile */}
                <button
                  className="lg:hidden text-black focus:outline-none"
                  onClick={() => setMobileMenuOpen(true)}
                  aria-label="Open menu"
                >
                  <Bars3Icon className="w-7 h-7" />
                </button>
                {/* Nav links centered (desktop only) */}
                <div
                  className={`flex-1 hidden lg:flex justify-center gap-8 ${
                    isScrolled ? "text-black" : "text-black"
                  }`}
                >
                  {[
                    { label: "About Us", to: "/#aboutus" },
                    { label: "Features", to: "/#features" },
                    { label: "Blogs", to: "/#blogs" },
                    { label: "FAQs", to: "/#faqs" },
                    { label: "Contact Us", to: "/#contactus" },
                  ].map((item) => (
                    <a
                      key={item.label}
                      href={item.to}
                      className={`text-black font-medium hover:text-[#E08681] transition whitespace-nowrap`}
                      onClick={e => {
                        e.preventDefault();
                        window.location.href = item.to;
                      }}
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
                {/* Login button right-aligned and smaller (desktop only) */}
                <div className="flex-1 hidden lg:flex justify-end gap-2">
                  <Button
                    className="px-3 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                    onClick={() => navigate("/company-register")}
                  >
                    Register
                  </Button>
                  <Button
                    className="px-4 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                    style={{ minWidth: "80px" }}
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </Button>
                </div>
              </div>
              {/* Mobile Menu Drawer */}
              {mobileMenuOpen && (
                <div
                  className="fixed inset-0 z-[999] bg-black/40 lg:hidden"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <div
                    className="absolute top-0 right-0 w-4/5 max-w-xs h-full bg-pink-100 shadow-lg flex flex-col p-4  gap-6 overflow-y-auto"
                    onClick={(e) => e.stopPropagation()}
                    style={{ minHeight: "100vh" }}
                  >
                    <div className="flex justify-between items-center mb-4">
                    <img
                        src={require("./dashboard/images/AECP_logo.png")}
                        alt="AECP Logo"
                        style={{ height: "90px", width: "auto", marginRight: "16px" }}
                      />
                      <button
                        onClick={() => setMobileMenuOpen(false)}
                        aria-label="Close menu"
                      >
                        <XMarkIcon className="w-7 h-7 text-white" />
                      </button>
                    </div>
                    <nav className="flex flex-col gap-4 items-center">
                      {["About Us", "Features", "Blogs", "FAQs", "Contact Us"].map(
                        (item, idx) => (
                          <a
                            key={item}
                            href={`#${item.toLowerCase().replace(/ /g, "")}`}
                            className="text-white font-medium text-lg py-2 px-2 rounded hover:bg-[#13c9a7]/20 transition"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            {item}
                          </a>
                        )
                      )}
                    </nav>
                    <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                       onClick={() => {
                        setMobileMenuOpen(false);
                        navigate("/company-register");
                      }}
                    >
                      Register
                    </button>
                    <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                       onClick={() => {
                        setMobileMenuOpen(false);
                        navigate("/login");
                      }}
                    >
                      Login
                    </button>
                  </div>
                </div>
              )}
            </Navbar>

      {/* Decorative Backgrounds - Hidden on mobile */}
      <img
        src={DecoRightBlog1}
        alt="deco"
        className="absolute right-0 top-[120%] w-[20%] z-0 hidden lg:block transform translate-x-1/4 -translate-y-1/4"
      />
      <img
        src={DecoRightBlog2}
        alt="deco"
        className="absolute left-[3%] top-[60%] w-[20%] z-0 hidden lg:block transform -translate-x-1/4"
      />
      <img
        src={DecoRightBlog3}
        alt="deco"
        className="absolute left-[3%] top-[95%] w-[15%] z-0 hidden lg:block transform -translate-x-1/4"
      />
      <img
        src={DecoRightBlog4}
        alt="deco"
        className="absolute left-[3%] top-[100%] w-[20%] z-0 hidden lg:block transform -translate-x-1/4 translate-y-1/4"
      />

      {/* Blog Content */}
      <div className="container mx-auto mt-24  pb-10 px-4 flex flex-col items-center relative z-10">
        <div className="w-full max-w-2xl">
          <div className="bg-gray-200 rounded-xl p-4 md:p-6 mb-5 shadow flex flex-col items-center gap-4 relative min-h-[24rem] lg:h-96 w-full lg:w-[120%]">
            <div className="flex-1 w-full">
              <div className="bg-[#ffffff] rounded-lg shadow-md p-4 relative w-full lg:absolute lg:top-24 lg:-left-44 lg:w-[60%] mb-4 lg:mb-0">
                <div className="flex justify-start">
                  <span className="inline-block bg-gray-400 text-white text-xs font-semibold px-4 py-2 rounded mb-2 shadow-md">
                    {blog.category}
                  </span>
                </div>
                <Typography
                  variant="h4"
                  className="font-bold mb-2 text-[#23235f] break-words text-lg md:text-2xl"
                  style={{ lineHeight: "1.3" }}
                >
                  {blog.title}
                </Typography>
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <img
                    src={require("./dashboard/images/profile2.png")}
                    alt="author"
                    className="w-6 h-6 md:w-8 md:h-8 rounded-full"
                  />
                  <span className="text-[#23235f] font-semibold text-xs md:text-sm">
                    {blog.author}
                  </span>
                  <span className="text-gray-400 text-xs">|</span>
                  <span className="text-gray-400 text-xs">{blog.date}</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-auto">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full lg:w-[120%] h-auto object-cover rounded-lg border border-gray-200 lg:hidden"
              />
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full absolute top-10 right-10 lg:w-[50%] h-auto object-cover rounded-lg border border-gray-200 hidden lg:block"
              />
            </div>
          </div>
          <div
            className="prose prose-sm md:prose-lg max-w-none text-[#23235f] mb-6 md:mb-10 text-sm md:text-base"
            style={{ whiteSpace: "pre-line" }}
          >
            {blog.content}

            <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold  text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle}
              </Typography>

              {blog.content2}
            </div>
            <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold mb-2 text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle3}
              </Typography>
            </div>
            <div>{blog.content4}</div>
            <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold mb-2 text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle2}
              </Typography>
            </div>
            {blog.content3 && (
              <ul className="list-disc pl-6">
                {blog.content3
                  .split("\n")
                  .filter((item) => item.trim())
                  .map((item, index) => (
                    <li key={index} className="mb-2">
                      {item.trim()}
                    </li>
                  ))}
              </ul>
            )}
          </div>
          <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold  text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle4}
              </Typography>

              {blog.content5}

              <div className="mt-5">
                <Typography
                  variant="h6"
                  className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                >
                  {blog.subtitle1}
                
                </Typography>
                {blog.subcontent1}
                <div className="mt-2">
                  <Typography
                    variant="h6"
                    className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                  >
                    {blog.subcontent2}
                  </Typography>
                  {blog.subcontent3}
                  <div className="mt-2">
                    {blog.subcontent4}
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Typography
                  variant="h6"
                  className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                >
                  {blog.subtitle2}
                
                </Typography>
                {blog.subcontent5}
                <div className="mt-2">
                  <Typography
                    variant="h6"
                    className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                  >
                    {blog.subcontent6}
                  </Typography>
                  {blog.subcontent7}
                  <div className="mt-2">
                    {blog.subcontent8}
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Typography
                  variant="h6"
                  className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                >
                  {blog.subtitle3}
                
                </Typography>
                {blog.subcontent9}
                <div className="mt-2">
                  <Typography
                    variant="h6"
                    className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                  >
                    {blog.subcontent10}
                  </Typography>
                  {blog.subcontent11}
                  <div className="mt-2">
                    {blog.subcontent12}
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Typography
                  variant="h6"
                  className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                >
                  {blog.subtitle4}
                
                </Typography>
                {blog.subcontent13}
                <div className="mt-2">
                  <Typography
                    variant="h6"
                    className="font-bold  text-[#23235f] text-base md:text-lg mb-2"
                  >
                    {blog.subcontent14}
                  </Typography>
                  {blog.subcontent15}
                  <div className="mt-2">
                    {blog.subcontent16}
                  </div>
                </div>
              </div>
            </div>
          <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold  text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle5}
              </Typography>

              {blog.content6}
            </div>
          <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold  text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle6}
              </Typography>

              {blog.content7}
            </div>
          <div className="mt-5">
              <Typography
                variant="h6"
                className="font-bold  text-[#23235f] text-base md:text-lg"
              >
                {blog.contentTitle7}
              </Typography>

              {blog.content8}
            </div>
          <hr className="my-6 md:my-10 border-gray-200" />
          <div className="mb-4 md:mb-6 w-full">
            <Typography
              variant="h6"
              className="font-bold mb-2 text-[#23235f] text-base md:text-lg"
            >
              Join the conversation
            </Typography>
            <textarea
              className="w-full rounded-xl border-2 px-3 md:px-4 py-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-pink-200"
              placeholder="Comments"
              rows={4}
            />
            <div className="flex items-center mt-3 md:mt-4">
              <img
                src={require("./dashboard/images/profile2.png")}
                alt="user"
                className="w-6 h-6 md:w-8 md:h-8 rounded-full mr-2"
              />
              <Button className="bg-[#E08681] text-white font-bold px-4 md:px-6 py-1.5 md:py-2 text-sm rounded-full shadow hover:bg-[#f23e6b] transition-all">
                Post
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-[#E08681] rounded-t-3xl pt-4 pb-4 px-4 md:px-16 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
          <img
            src={require("./dashboard/images/AECP_logo.png")}
            alt="AECP Logo"
            style={{ height: "90px", width: "auto", marginRight: "16px" }}
          />
          <div className="flex gap-8 text-white/80 text-sm">
            <a href="#" className="hover:underline text-white">
              Privacy Policy
            </a>
            <a href="#" className="hover:underline text-white">
              Terms
            </a>
          </div>
        </div>
        <hr className="border-t border-white/30 mb-4" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <ul className="flex flex-wrap gap-4 md:gap-6 text-white/90 text-sm mb-2 md:mb-0">
            <li>
              <a href="#" className="hover:underline text-white">
                Home
              </a>
            </li>
            <li>
              <a href="#features" className="hover:underline text-white">
                Features
              </a>
            </li>
            <li>
              <a href="#blogs" className="hover:underline text-white">
                Blogs
              </a>
            </li>
            <li>
              <a href="#faqs" className="hover:underline text-white">
                FAQs
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:underline text-white">
                Contacts Us
              </a>
            </li>
          </ul>
          <div className="text-white/80 text-sm text-center md:text-right">
            © {new Date().getFullYear()} MINE-IT. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
